import React, { useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";

import "./style.css";
import { Avatar, Card, InputBase, Paper, Typography } from "@mui/material";
import ClassIcon from "@mui/icons-material/Class";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CardHeader from "@mui/material/CardHeader";
import { setContrato } from "../../services/auth";

function Menu({ contratos, idContrato, setIdContrato, setState }) {
  //organizar a lista de contratos, status == 'Contrato Ativo' primeiro, depois 'Contrato Aprovado' e por fim os demais
  contratos.sort((a, b) => {
    if (a.status === "Contrato Ativo" && b.status !== "Contrato Ativo") {
      return -1;
    }
    if (a.status !== "Contrato Ativo" && b.status === "Contrato Ativo") {
      return 1;
    }
    if (a.status === "Contrato Aprovado" && b.status !== "Contrato Aprovado") {
      return -1;
    }
    if (a.status !== "Contrato Aprovado" && b.status === "Contrato Aprovado") {
      return 1;
    }
    return 0;
  });

  const [list, setList] = useState([]);
  const [term, setTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState(term);
  const [listTt, setListTt] = useState([]);
  useEffect(() => {
    const timer = setTimeout(() => setTerm(searchQuery), 700);
    return () => clearTimeout(timer);
  }, [searchQuery]);
  useEffect(() => {
    if (term !== "") {
      if (term !== null) {
        let termTmp = String(term);
        termTmp = termTmp.toUpperCase();
        // eslint-disable-next-line array-callback-return
        let temp = listTt.filter((element) => {
          let { nome, endereco, cnpj, bairro, tiporesiduo, id } = element;
          nome = String(nome);
          nome = nome.toUpperCase();
          endereco = String(endereco);
          endereco = endereco.toUpperCase();
          cnpj = cnpj.toString();
          cnpj = String(cnpj);
          bairro = String(bairro);
          bairro = bairro.toUpperCase();
          tiporesiduo = String(tiporesiduo);
          tiporesiduo = tiporesiduo.toUpperCase();
          id = String(id);
          id = id.toUpperCase();
          if (nome.includes(termTmp)) {
            return element;
          }
          if (endereco.includes(termTmp)) {
            return element;
          }
          if (cnpj.includes(termTmp)) {
            return element;
          }
          if (bairro.includes(termTmp)) {
            return element;
          }
          if (tiporesiduo.includes(termTmp)) {
            return element;
          }
          if (id.includes(termTmp)) {
            return element;
          }
        });
        setList(temp);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term]);
  let initialized = false;
  useEffect(() => {
    if (!initialized) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      initialized = true;
      setList(contratos);
      setListTt(contratos);
    }
  }, [idContrato]);
  const searchHandler = (event) => {
    let text = event.target.value;
    if (text === "" || text == null) {
      setList(listTt);
      setSearchQuery("");
    } else {
      setSearchQuery(text);
    }
  };
  const [height, setWidth] = useState(0);
  useEffect(() => {
    const element = document.getElementById("home");
    if (element) {
      setWidth(element.getBoundingClientRect().height - 143); // or height
    }
  }, []);
  const renderContratos = (element, idx) => {
    let { status, nome, id, tiporesiduo, endereco, bairro } =
      element;
    return (
      <div
        key={idx}
        style={{ marginTop: 10, color: "var(--main-font)" }}
        onClick={() => {
          setIdContrato(id);
          setState(false);
          setContrato(id);
        }}
      >
        <Card
          className="cardPointer"
          style={
            id === idContrato
              ? { backgroundColor: "var(--main-white-color)" }
              : { backgroundColor: "var(--main-white-color-60)" }
          }
        >
          <CardHeader
            avatar={
              status === 'Contrato Ativo' ? (
                <Avatar
                  sx={{
                    backgroundColor: "var(--main-bg-color)",
                    width: 50,
                    height: 50,
                  }}
                >
                  <ClassIcon color={"var(--main-white-color)"} size={30} />
                </Avatar>
              ) : status === 'Contrato Aprovado' ? (
                <Avatar
                  sx={{ backgroundColor: "#FFD700", width: 50, height: 50 }}
                >
                  <ClassIcon color={"var(--main-white-color)"} size={30} />
                </Avatar>
              ) : (
                <Avatar
                  sx={{ backgroundColor: "#FFFFFF60", width: 50, height: 50 }}
                >
                  <ClassIcon style={{ color: "#a3a3a3" }} size={30} />
                </Avatar>
              )
            }
            action={
              id === idContrato ? <CheckCircleIcon color="success" /> : null
            }
            title={
              <>
                {"Contrato: " + id}
                <br></br>
                {status === "Contrato Aprovado"
                  ? "Status: Contrato Pendente"
                  : "Status: " + status}
              </>
            }
            subheader={<>{"Tipo: " + tiporesiduo}</>}
          />
          <CardContent style={{ marginTop: -20 }}>
            <Typography variant="body2">Nome: {nome}</Typography>
            <Typography variant="caption" color="text.secondary">
              Endereço: {endereco} <br />
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Bairro: {bairro}
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  };
  return (
    <div className="menu">
      <div style={{ width: "100%", textAlign: "center", fontSize: 26 }}>
        Contratos
      </div>
      <Paper
        sx={{
          p: "2px 10px",
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginTop: 2,
          marginBottom: 2,
        }}
      >
        <InputBase
          type="text"
          className="search"
          placeholder="Procurar Contrato"
          inputProps={{ "aria-label": "Procurar Contrato" }}
          onChange={searchHandler}
          value={searchQuery}
        />
        <div style={{ padding: "10px" }} aria-label="search">
          <SearchIcon style={{ color: "#a3a3a3" }} />
        </div>
      </Paper>
      <div>{list.map((elemeto, index) => renderContratos(elemeto, index))}</div>
    </div>
  );
}

export default Menu;
